import React, {FC, useState} from 'react'
import CommerciumLoaderHost from 'src/utils/CommerciumLoaderHost'
import {DashboardPeriodFilter, DashboardPeriodOption} from '../utils/dashboardPeriodUtils'
import {formatDashboardCurrency} from '../utils/parseDashboardReportResponse'
import {useSalesByChannel} from '../hooks/useSalesByChannel'

type Props = {
  filterOptions: DashboardPeriodOption[]
}

const SalesByChannelCard: FC<Props> = ({filterOptions}) => {
  const [period, setPeriod] = useState<DashboardPeriodFilter>('this_month')
  const {rows, loading} = useSalesByChannel(period)

  return (
    <div className='dashboard-panel-card dashboard-widget-card mb-0'>
      <div className='dashboard-panel-header'>
        <h3>Sales By Channel</h3>
        <select
          className='dashboard-filter-select dashboard-period-select'
          value={period}
          onChange={(e) => setPeriod(e.target.value as DashboardPeriodFilter)}
        >
          {filterOptions.map((option) => (
            <option key={option.key} value={option.key}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className='dashboard-panel-body'>
        {loading ? (
          <CommerciumLoaderHost variant='section' layout='centered' />
        ) : rows.length > 0 ? (
          <table className='dashboard-data-table'>
            <thead>
              <tr>
                <th>Channel</th>
                <th className='text-end'>Amount</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={`${row.platformId || 'channel'}-${row.channel}`}>
                  <td>{row.channel}</td>
                  <td className='text-end fw-semibold'>
                    {formatDashboardCurrency(row.amount, row.currency)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='dashboard-empty fs-7'>No sales data available.</div>
        )}
      </div>
    </div>
  )
}

export default SalesByChannelCard
